<template>
  <header class="kanban-header" data-component="Kanban/KanbanHeader">

    <!-- ── Top row: title + totals ──────────────────────────────────────── -->
    <div class="kanban-header__top">
      <div class="kanban-header__left">
        <div class="kanban-header__title-group">
          <i class="fas fa-columns kanban-header__icon"></i>
          <h2 class="kanban-header__title">Kanban — Visites</h2>
        </div>
        <p class="kanban-header__subtitle">Vue synthétique par statut</p>
      </div>

      <div class="kanban-header__stats">
        <div class="kanban-header__stat-total">
          <span class="kanban-header__stat-value">{{ stats.total }}</span>
          <span class="kanban-header__stat-label">visite{{ stats.total > 1 ? 's' : '' }}
            <template v-if="isFiltered"> filtrée{{ stats.total > 1 ? 's' : '' }}</template>
          </span>
        </div>

        <div class="kanban-header__pills">
          <span
            v-for="col in stats.columns"
            :key="col.id"
            class="kanban-header__pill"
            :style="{ '--pill-color': col.color }"
            :title="col.label"
          >
            <i :class="col.icon"></i>
            {{ col.count }}
          </span>
        </div>
      </div>
    </div>

    <!-- ── Filter bar ───────────────────────────────────────────────────── -->
    <div class="kanban-header__filters">

      <!-- Recherche libre -->
      <div class="kanban-header__filter kanban-header__filter--search">
        <i class="fas fa-search kanban-header__filter-icon"></i>
        <input
          v-model="localSearch"
          type="text"
          class="kanban-header__filter-input"
          placeholder="Rechercher (NSIL, ville, adresse…)"
          @input="onSearchInput"
        />
        <button
          v-if="localSearch"
          class="kanban-header__filter-clear"
          @click="clearSearch"
          aria-label="Effacer la recherche"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <!-- Mandant -->
      <div class="kanban-header__filter" v-if="filterOptions.mandants.length">
        <i class="fas fa-building kanban-header__filter-icon"></i>
        <select v-model="localMandant" class="kanban-header__filter-select" @change="emitFilters">
          <option value="">Tous les mandants</option>
          <option v-for="m in filterOptions.mandants" :key="m" :value="m">{{ m }}</option>
        </select>
      </div>

      <!-- Technicien -->
      <div class="kanban-header__filter" v-if="filterOptions.managers.length">
        <i class="fas fa-user kanban-header__filter-icon"></i>
        <select v-model="localManager" class="kanban-header__filter-select" @change="emitFilters">
          <option value="">Tous les techniciens</option>
          <option v-for="m in filterOptions.managers" :key="m.id" :value="m.id">{{ m.name }}</option>
        </select>
      </div>

      <!-- Occupation -->
      <div class="kanban-header__filter">
        <i class="fas fa-home kanban-header__filter-icon"></i>
        <select v-model="localOccupancy" class="kanban-header__filter-select" @change="emitFilters">
          <option value="">Toutes occupations</option>
          <option value="Vacant">Vacant</option>
          <option value="Occupé">Occupé</option>
        </select>
      </div>

      <!-- Reset all -->
      <button
        v-if="isFiltered"
        class="kanban-header__filter-reset"
        @click="resetFilters"
        title="Réinitialiser les filtres"
      >
        <i class="fas fa-filter-slash"></i>
        <span>Réinitialiser</span>
      </button>

    </div>
  </header>
</template>

<script>
// Debounce utilitaire
function debounce(fn, delay) {
  let timer
  return function (...args) {
    clearTimeout(timer)
    timer = setTimeout(() => fn.apply(this, args), delay)
  }
}

export default {
  name: 'KanbanHeader',
  props: {
    stats: {
      type: Object,
      required: true
      // stats shape: { total: Number, columns: [{ id, label, icon, color, count }] }
    },
    filterOptions: {
      type: Object,
      default: () => ({ mandants: [], managers: [] })
      // filterOptions: { mandants: String[], managers: [{ id, name }] }
    }
  },
  emits: ['filters-changed'],
  data() {
    return {
      localSearch:   '',
      localMandant:  '',
      localManager:  '',
      localOccupancy: ''
    }
  },
  computed: {
    isFiltered() {
      return !!(this.localSearch || this.localMandant || this.localManager || this.localOccupancy)
    }
  },
  created() {
    // Debounce de la recherche textuelle
    this.onSearchInput = debounce(this.emitFilters, 300)
  },
  methods: {
    emitFilters() {
      this.$emit('filters-changed', {
        search:    this.localSearch.trim(),
        mandant:   this.localMandant,
        managerId: this.localManager,
        occupancy: this.localOccupancy
      })
    },
    clearSearch() {
      this.localSearch = ''
      this.emitFilters()
    },
    resetFilters() {
      this.localSearch   = ''
      this.localMandant  = ''
      this.localManager  = ''
      this.localOccupancy = ''
      this.emitFilters()
    }
  }
}
</script>

<style lang="scss" scoped>
@use './KanbanHeader.scss';
</style>
